import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { AppSignInPage } from './AppSignInPage';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => AppSignInPage,
  },
});

export const appModuleSignIn = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
